<template>
    <v-card flat>
        <v-layout row wrap align-center>
            <v-flex xs12 md6>
                <v-combobox
                    v-model="couponItems"
                    chips
                    deletable-chips
                    multiple
                    append-icon=""
                    class="pa-0"
                    :error-messages="$language.translate(error)"
                >
                    <template v-slot:selection="{ item, parent, selected }">
                        <v-chip
                            color="primary"
                            close
                            text-color="white"
                            @input="!$event ? (couponItems = couponItems.filter(c => c !== item)) : null"
                        >
                            {{ item }}
                        </v-chip>
                    </template>
                </v-combobox>
            </v-flex>

            <v-flex xs12 md6>
                <v-btn block :color="buttonColor" @click="applyCoupon(coupon)" :loading="loading" class="ma-0">
                    {{ 'redeem voucher' | translation }}
                </v-btn>
            </v-flex>
            <v-flex xs12>
                {{ 'redeem-voucher-text' | translation }}
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import module from './store/coupon';
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';

const moduleName = 'Coupon';
const { mapActions } = createNamespacedHelpers(moduleName);

if (!Vue.$store.state[moduleName]) {
    Vue.$store.registerModule(moduleName, module);
}

export default {
    name: moduleName,
    data() {
        return {
            coupon: '',
        };
    },
    created() {
        this.ensureCoupons();
        this.unwatch = this.$store.watch(
            () => this.$store.state.Registration.email,
            () => {
                this.ensureCoupons();
            },
        );
    },
    beforeDestroy() {
        this.unwatch();
    },
    props: {
        buttonColor: {
            default: 'primary',
            type: String,
        },
    },
    computed: {
        ...mapState(moduleName, ['couponCodes', 'loading', 'error']),
        basketOptions() {
            return this.$basket.getBasketOptions();
        },
        getBasketSubTotal() {
            return this.$basket.getBasketSubTotal();
        },
        getShippingTotal() {
            return this.$basket.getShippingTotal();
        },
        currency() {
            return this.$currency.getSelected();
        },
        couponItems: {
            get() {
                return this.couponCodes;
            },
            set(codes) {
                codes.filter(c => !this.couponCodes.includes(c)).forEach(c => this.applyCoupon(c));
                this.couponCodes.filter(c => !codes.includes(c)).forEach(c => this.removeCoupon({ couponCode: c }));
            },
        },
    },
    methods: {
        ...mapMutations(moduleName, ['setError']),
        ...mapActions({
            applyCouponAction: 'applyCoupon',
        }),
        ...mapActions(['removeCoupon']),
        applyCoupon(couponCode) {
            this.applyCouponAction({ couponCode })
                .then(() => {
                    this.coupon = '';
                })
                .catch(e => {
                    this.setError(e);
                });
        },
        ensureCoupons() {
            const coupon = this.basketOptions.coupon;
            const failedCoupons = this.$coupon.getFailedCoupons();

            if (coupon && typeof coupon === 'string') {
                this.applyCouponAction({ couponCode: coupon });
            } else if (Array.isArray(coupon)) {
                coupon.forEach(async couponCode => {
                    await this.applyCouponAction({ couponCode });
                });
            }

            failedCoupons.forEach(async couponCode => {
                await this.applyCouponAction({ couponCode, silent: true }).then(result => {
                    if (result && result.code) {
                        this.$coupon.removeFailedCoupon(couponCode);
                    }
                });
            });
        },
    },
    watch: {
        getBasketSubTotal(val, oldVal) {
            this.setError(null);
            if (val !== oldVal) {
                this.ensureCoupons();
            }
        },
        getShippingTotal(val, oldVal) {
            this.setError(null);
            if (val !== oldVal) {
                this.ensureCoupons();
            }
        },
        currency(val, oldVal) {
            if (oldVal && val !== oldVal) {
                this.ensureCoupons();
            }
        },
    },
};
</script>
